import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../config/api';

const SiteContext = createContext();

export const useSite = () => {
  const context = useContext(SiteContext);
  if (!context) {
    throw new Error('useSite must be used within a SiteProvider');
  }
  return context;
};

export const SiteProvider = ({ children }) => {
  const [sites, setSites] = useState([]);
  const [selectedSite, setSelectedSite] = useState('all');
  const [loading, setLoading] = useState(true);
  const [updateTrigger, setUpdateTrigger] = useState(0);
  
  const handleSetSelectedSite = (siteId) => {
    console.log('Site selection changed:', selectedSite, '->', siteId);
    setSelectedSite(siteId);
    setUpdateTrigger(prev => prev + 1);
  };

  const fetchSites = async () => {
    try {
      const token = localStorage.getItem('token');
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      const response = await axios.get(`${API_BASE_URL}/api/sites`, {
        headers: { 
          Authorization: `Bearer ${token}`,
          'x-tenant-id': user.tenantId
        }
      });
      setSites(response.data.sites || []);
    } catch (error) {
      console.error('Error fetching sites:', error);
      setSites([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSites();
  }, []);

  return (
    <SiteContext.Provider value={{
      sites,
      selectedSite,
      setSelectedSite: handleSetSelectedSite,
      loading,
      fetchSites,
      updateTrigger
    }}>
      {children}
    </SiteContext.Provider>
  );
};